/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import calenderIcon from "../../assets/icons/calender.svg";
import caretDownIcon from "../../assets/icons/caret-down-dark.svg";
import { currencyFormat } from "../../library/currency";
import { setBookingId, setChildId, setMembershipStatus } from "../../store/features/deviceSlice";
import addChildrenSchema from "../../validation/membershipChildrenSchema";
import { useDrawer } from "../drawer/DrawerProvider";
import Payment from "../payment/Payment";
import getOrigins from "../../utils/getOrigins";
import ErrorMessage from "../ui/ErrorMessage";
import useAuthWatcher from "../../hooks/useAuthWatcher";

export default function Membership({ item }) {
  const { membershipStatus } = useSelector((state) => state.deviceSlice);
  const { openDrawer } = useDrawer();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState();
  const handleSignupDrawer = useCallback(() => {
    if (!userData) {
      openDrawer(
        <iframe
          src={`${getOrigins(window)}/login?embed=true`}
          height="100%"
          width="100%"
          title="Login"
        />,
        "",
      );
    }
  }, [userData, openDrawer]);
  const previewDrawerHandler = useCallback(() => {
    if (item?.applicable === "children") {
      openDrawer(<MembershipChildrenPreview item={item} />, "Child Details");
      dispatch(setMembershipStatus(false))
    } else {
      openDrawer(<MembershipPreview item={item} />, "Membership  Preview");
      dispatch(setMembershipStatus(false));
    }
  }, [dispatch, item, openDrawer]);

  useEffect(()=> {
    if (membershipStatus) {
      previewDrawerHandler()
    }
  },[membershipStatus, previewDrawerHandler])

  useAuthWatcher(setUserData);

  return (
    <div className={`${Style.bg_gray_200} pb-2`} style={{ height: "322px" }}>
      <div
        className={`${Style.bg_primary} ${Style.fs_16} ${Style.fw_600} text-light d-flex align-items-center justify-content-center`}
        style={{ minHeight: "32px", textAlign: "center", justifyContent: "center", textWrap:"wrap" , wordBreak:"break-word"}}
      >
        {item?.name}
      </div>
      <div
        className="d-flex flex-column gap-2 px-2"
        style={{ height: "245px", overflow: "hidden" }}
      >
        <div className="text-center pt-2">
          {item?.offer_price != null && item?.offer_price > 1 ? (
            <div
              className={`${Style.fs_20} ${Style.fw_350} ${Style.text_primary} text-decoration-line-through`}
              style={{
                lineHeight: "26.6px",
              }}
            >
              {currencyFormat(item?.price)}
            </div>
          ) : (
            <div
              className={`${Style.fs_20} ${Style.fw_350} ${Style.text_primary} text-decoration-line-through`}
              style={{
                lineHeight: "26.6px",
                height: "28px",
              }}
            />
          )}
          <div
            className={`${Style.fs_48} ${Style.fw_600} ${Style.text_primary}`}
            style={{
              lineHeight: "60px",
              marginTop: "-8px",
            }}
          >
            {currencyFormat(item?.offer_price ?? item?.price)}
          </div>
        </div>
        <div
          className={`${Style.fs_16} ${Style.fw_350} ${Style.line_height}  text-start px-3`}
          dangerouslySetInnerHTML={{ __html: item.description }}
        />
      </div>
      <div className="px-4">
        {userData && (
          <button
            type="button"
            onClick={previewDrawerHandler}
            className={`${Style.fs_16} ${Style.fw_600} ${Style.bg_primary} text-light border-0 w-100 shadow`}
            style={{ height: "34px" }}
          >
            Buy Membership
          </button>
        )}
        {!userData && (
          <button
            type="button"
            onClick={handleSignupDrawer}
            className={`${Style.fs_16} ${Style.fw_600} ${Style.bg_primary} text-light border-0 px-4 w-100 shadow`}
            style={{ height: "34px" }}
          >
            Login to Buy
          </button>
        )}
      </div>
    </div>
  );
}
function MembershipPreview({ item }) {
  const dispatch = useDispatch();
  const { openDrawer } = useDrawer();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const { childId } = useSelector((state) => state.deviceSlice);
  const handlePaymentDrawer = () => {
    openDrawer(<Payment />, "Select Payment Method");
  };
  const confirmPurchase = async () => {
    if (userData) {
      setLoading(true);
      const data = { id: item?.id };
      if (item?.applicable === "children") {
        data.children_id = childId;
      }
      const res = await api.purchaseMembership(data);
      if (res.status === 201) {
        if (res.data?.data?.booking_id) {
          dispatch(setBookingId(res.data.data.booking_id));
          handlePaymentDrawer();
        }
      } else if (res.status === 422) {
        Object.values(res.data.data).forEach((error) => {
          toast.error(error[0]);
        });
      } else {
        toast.error("Server side error!Please try again later");
      }
      setLoading(false);
    }
  };

  useAuthWatcher(setUserData);

  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="profile-container overflow-y-scroll">
        <div className={`px-0 mt-2 ${Style.bg_gray_200}`}>
          <div
            className={`${Style.fs_20} ${Style.fw_400} d-flex align-items-start gap-2 px-3`}
          >
            {/* Fixed width for "Membership -" */}
            <div
              className={`${Style.fw_600} ${Style.fs_20} text-danger flex-shrink-0`}
            >
              Membership - &nbsp;
            </div>

            {/* Expands to take remaining space */}
            <div className={`${Style.fw_400} ${Style.fs_20} flex-grow-1`}>
              {item.name}
            </div>
          </div>
          {item.description && (
            <div className="d-flex flex-column px-3 mt-2">
              <div className={`${Style.fw_600} ${Style.fs_20} text-danger`}>
                Descripton
              </div>
              <div
                className={`${Style.fw_350} ${Style.fs_20}`}
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          )}
        </div>
        <div
          className={`${Style.bg_gray_200} d-flex flex-column mt-2 p-2 mb-2`}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className={`${Style.fs_20} ${Style.fw_350}`}>Duration</div>
            <div className={`${Style.fs_20} ${Style.fw_350}`}>
              {item?.duration_type === "date"
                ? new Date(
                    item?.duration
                      .trim()
                      .split("\n")
                      .pop()
                      .trim()
                      .split(" - ")[1]
                  )
                    .toISOString()
                    .slice(0, 10)
                : item.duration_type === "month"
                  ? `${item.duration} Month`
                  : item.duration_type === "day"
                    ? `${item.duration} Days`
                    : `${item.duration} Hours`}
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className={`${Style.fs_20} ${Style.fw_400}`}>
              Membership Price
            </div>
            <div className={`${Style.fs_20} ${Style.fw_400}`}>
              {currencyFormat(item.price)}
            </div>
          </div>
          {item.offer_price && (
            <div className="d-flex justify-content-between align-items-center text-danger flex-wrap border-bottom border-black">
              <div className={`${Style.fs_20} ${Style.fw_350}`}>
                Discount Amount
              </div>
              <div className={`${Style.fs_20} ${Style.fw_350}`}>
                {currencyFormat(item.price - item.offer_price)}
              </div>
            </div>
          )}
          <div
            className={`${Style.fs_20} ${Style.fw_600} d-flex justify-content-between align-items-center`}
          >
            <div>Grand Total</div>
            <div>{currencyFormat(item?.offer_price ?? item?.price)}</div>
          </div>
        </div>
        <div className="px-0">
          {item?.terms && (
            <div
              className={`${Style.bg_gray_200} d-flex flex-column gap-2 px-3`}
            >
              <div className={`${Style.fw_600} ${Style.fs_20} text-danger`}>
                Terms and Conditions
              </div>
              <div
                className={`${Style.fw_350} ${Style.fs_20}`}
                dangerouslySetInnerHTML={{ __html: item.terms }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="membership-bottom">
        {!loading && (
          <button
            type="button"
            onClick={confirmPurchase}
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 cart-checkout-btn`}
          >
            Proceed to Payment
          </button>
        )}
        {loading && (
          <button
            disabled
            type="button"
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 cart-checkout-btn`}
          >
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </button>
        )}
      </div>
    </div>
  );
}
function MembershipChildrenPreview({ item }) {
  const { childId } = useSelector((state) => state.deviceSlice);
  const dispatch = useDispatch();
  const { openDrawer } = useDrawer();
  const previewDrawerHandler = () => {
    openDrawer(<MembershipPreview item={item} />, "Membership  Preview");
  };
  const [addMode, setAddMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [children, setChildren] = useState([]);
  const initial = {
    name: "",
    date_of_birth: null,
    gender: "",
    class: "",
    school: "",
  };
  const [credentials, setCredentials] = useState(initial);
  const credentialHandler = (event) => {
    const { name, value } = event.target;
    setCredentials({ ...credentials, [name]: value });
  };
  const selectedDate = (name, value) => {
    setCredentials({ ...credentials, [name]: value });
  };
  const onchangeHandler = (event) => {
    const { value } = event.target;
    dispatch(setChildId(value));
  };
  const fetch = useCallback(async () => {
    const res = await api.getChildren();
    if (res.status === 200) {
      const activeChildren = res.data.data.filter(
        (resData) => resData.status === 1
      );
      setChildren(activeChildren);
    }
  }, []);
  const [errors, setErrors] = useState(null);
  const saveChildrenHandler = async () => {
    try {
      const result = addChildrenSchema.safeParse(credentials);
      if (result.success) {
        setErrors(null);
        setLoading(true);
        credentials.date_of_birth = new Date(credentials.date_of_birth)
          .toISOString()
          .slice(0, 10);
        const res = await api.addChildren(credentials);
        if (res.status === 201) {
          toast.success("Child added successfully");
          dispatch(setChildId(res.data.data.id));
          await fetch();
          setCredentials(initial);
          setAddMode(false);
        } else if (res.status === 422) {
          Object.values(res.data.data).forEach((error) => {
            toast.error(error[0]);
          });
        } else {
          toast.error("Server side error!Please try again later");
        }
        setLoading(false);
      } else {
        const errorsObject = result.error.errors.reduce((acc, error) => {
          const path = error.path.join(".");
          acc[path] = error.message;
          return acc;
        }, {});
        setErrors(errorsObject);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    fetch();
  }, [fetch]);
  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="profile-container overflow-y-scroll pt-2 pb-2">
        <div className={`${Style.profile_input} position-relative py-3`}>
          <select
            name="children"
            className={`${childId ? "text-dark" : Style.color_gray_200} w-100 rounded`}
            onChange={onchangeHandler}
            value={childId}
          >
            <option value="" disabled={childId}>
              Select Child
            </option>
            {children.map((child) => (
              <option key={child.id} value={child.id}>
                {child.name}
              </option>
            ))}
          </select>
          <img
            src={caretDownIcon}
            alt="caret-down"
            className="position-absolute"
            style={{
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />
        </div>
        <div>
          <button
            type="button"
            onClick={() => setAddMode(!addMode)}
            className={`${Style.bg_primary} ${Style.fw_600} ${Style.fs_16} text-light border-0 rounded p-2`}
          >
            Add Child
          </button>
        </div>
        {addMode && (
          <div className="d-flex flex-column gap-2">
            <div
              className={`${Style.text_primary} ${Style.fw_600} ${Style.fs_20} py-3`}
            >
              Provide your Child&apos;s Details
            </div>
            <div className={Style.profile_input}>
              <input
                type="text"
                name="name"
                className="w-100 rounded"
                placeholder="Enter Name"
                onChange={credentialHandler}
                required
              />
              {errors && errors.name && <ErrorMessage message={errors.name} />}
            </div>
            <div
              className={`${Style.profile_input} ${Style.children_custom_date} position-relative`}
            >
              <DatePicker
                className="w-100 rounded"
                selected={credentials.date_of_birth}
                onChange={(date) => selectedDate("date_of_birth", date)}
                dateFormat="dd/MM/yyyy"
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                showMonthDropdown
                maxDate={new Date()}
                placeholderText="Select Date of Birth"
              />
              <img
                src={calenderIcon}
                alt="caret-down"
                className="position-absolute"
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
            {errors && errors.date_of_birth && (
              <div>
                <ErrorMessage message={errors.date_of_birth} />
              </div>
            )}
            <div className={`${Style.profile_input} position-relative`}>
              <select
                name="gender"
                className={`${credentials?.gender ? "text-dark" : Style.color_gray_200} w-100 rounded`}
                onChange={credentialHandler}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Boy</option>
                <option value="female">Girl</option>
              </select>
              <img
                src={caretDownIcon}
                alt="caret-down"
                className="position-absolute"
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
            {errors && errors.gender && (
              <div>
                <ErrorMessage message={errors.gender} />
              </div>
            )}
            <div className={Style.profile_input}>
              <input
                type="text"
                name="class"
                className="w-100 rounded"
                placeholder="Enter Class"
                onChange={credentialHandler}
              />
              {errors && errors.class && (
                <ErrorMessage message={errors.class} />
              )}
            </div>
            <div className={Style.profile_input}>
              <input
                type="text"
                name="school"
                className="w-100 rounded"
                placeholder="Enter School Name"
                onChange={credentialHandler}
              />
              {errors && errors.school && (
                <ErrorMessage message={errors.school} />
              )}
            </div>
            <div className="pt-3">
              {!loading && (
                <button
                  type="button"
                  onClick={saveChildrenHandler}
                  className={`${Style.bg_primary} ${Style.fs_14} ${Style.fw_400} text-light rounded-1 p-1 border-0 w-100 save-btn`}
                >
                  Save Child
                </button>
              )}
              {loading && (
                <button
                  disabled
                  type="button"
                  className={`${Style.bg_primary} ${Style.fs_14} ${Style.fw_400} text-light rounded-1 p-1 border-0 w-100 save-btn`}
                >
                  <Spinner animation="border" role="status" size="sm">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </button>
              )}
            </div>
          </div>
        )}
        {!addMode && (
          <div className="d-flex flex-column gap-2">
            <div
              className={`${Style.text_primary} ${Style.fw_600} ${Style.fs_20} py-3`}
            >
              Provide your Child&apos;s Details
            </div>
            <div className={Style.profile_input}>
              <input
                disabled
                type="text"
                name="name"
                className="w-100 rounded"
                placeholder="Enter Name"
                onChange={credentialHandler}
                value={
                  children.find((child) => child.id === Number(childId))
                    ? children.find((child) => child.id === Number(childId))
                        .name
                    : ""
                }
                required
              />
            </div>
            <div
              className={`${Style.profile_input} ${Style.children_custom_date} position-relative`}
            >
              <DatePicker
                disabled
                className="w-100 rounded"
                selected={credentials.date_of_birth}
                onChange={(date) => selectedDate("date_of_birth", date)}
                dateFormat="dd/MM/yyyy"
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                showMonthDropdown
                maxDate={new Date()}
                placeholderText="Select Date of Birth"
                value={
                  children.find((child) => child.id === Number(childId))
                    ? children.find((child) => child.id === Number(childId))
                        .date_of_birth
                    : ""
                }
              />
              <img
                src={calenderIcon}
                alt="caret-down"
                className="position-absolute"
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
            <div className={`${Style.profile_input} position-relative`}>
              <select
                disabled
                name="gender"
                className={`${childId ? "text-dark" : Style.color_gray_200} w-100 rounded`}
                onChange={credentialHandler}
                required
                value={
                  children.find((child) => child.id === Number(childId))
                    ? children.find((child) => child.id === Number(childId))
                        .gender
                    : ""
                }
              >
                <option value="">Select Gender</option>
                <option value="male">Boy</option>
                <option value="female">Girl</option>
              </select>
              <img
                src={caretDownIcon}
                alt="caret-down"
                className="position-absolute"
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
            <div className={Style.profile_input}>
              <input
                disabled
                type="text"
                name="class"
                className="w-100 rounded"
                placeholder="Enter Class"
                onChange={credentialHandler}
                value={
                  children.find((child) => child.id === Number(childId))
                    ? children.find((child) => child.id === Number(childId))
                        .class
                    : ""
                }
              />
            </div>
            <div className={Style.profile_input}>
              <input
                disabled
                type="text"
                name="school"
                className="w-100 rounded"
                placeholder="Enter school name"
                onChange={credentialHandler}
                value={
                  children.find((child) => child.id === Number(childId))
                    ? children.find((child) => child.id === Number(childId))
                        .school
                    : ""
                }
              />
            </div>
          </div>
        )}
      </div>
      <div className="membership-bottom">
        <button
          type="button"
          disabled={!childId}
          onClick={previewDrawerHandler}
          className={`${childId ? Style.bg_primary : "bg-secondary"} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 cart-checkout-btn`}
        >
          Proceed to Checkout
        </button>
      </div>
    </div>
  );
}
